import '.a{display:flex;}.ssr-plugin'
import '.dn{aspect-ratio:1/1;}.ssr-plugin'
import '.bo{flex-shrink:0;}.ssr-plugin'
import '.do{padding:0.5rem;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import useMediaQuery from '@app/util/useMediaQuery'
import {
  faCheck,
  faWarning,
  IconDefinition,
} from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Style, styled } from 'inlines'

export type Variant = 'success' | 'error'

const variantStyle: Record<Variant, Style> = {
  success: {
    color: 'var(--success-mint',
    background: 'var(--success-green)',
  },
  error: {
    color: 'var(--shades-red-200)',
    background: 'var(--semantic-red)',
  },
}

const iconVariant: Record<Variant, IconDefinition> = {
  success: faCheck,
  error: faWarning,
}

export type IconProps = {
  variant: Variant
  icon?: IconDefinition
}

export const ToastIcon = ({ variant }: IconProps) => {
  const isMobile = useMediaQuery()
  return (
    <styled.div className="a dn bo do b f"
      style={{
        width: isMobile ? '2.75rem' : '3.5rem',
        height: isMobile ? '2.75rem' : '3.5rem',
        borderRadius: isMobile ? '0.75rem' : '1rem',
        ...variantStyle[variant],
      }}
    >
      <FontAwesomeIcon
        icon={iconVariant[variant]}
        fontSize={isMobile ? '1.5rem' : '2.125rem'}
      />
    </styled.div>
  )
}
